/* eslint-disable react/display-name */
import { titleSelector } from '@smartsheet-dataflow/formjs';
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import React from 'react';
import { useSelector } from 'react-redux';
import { PartialBy } from '../../../utils/types';

interface WithFormJSTitleProps {
  title: string;
}

export const withFormJSTitle =
  <P extends EntityId & WithFormJSTitleProps>(
    Component: React.ComponentType<P>
  ) =>
  (props: PartialBy<P, 'title'>) => {
    const title = useSelector(titleSelector(props.id));
    return <Component {...(props as P)} title={title} />;
  };
